import React from 'react';
import styles from './AderenciaDePrecosHeader.module.scss';

export const AderenciaDePrecosHeader = () => (
    <div className={styles.container}>
        <h3 className={styles.title} >Aderência de preços</h3>
        <p className={styles.subtitle}>
            Envie seus parâmetros para alimentar o painel de aderência de preços.
        </p>
    </div>
);
